import Logo from '../../assets/logo-small.svg';

export default function FooterClient() {


    return (
        <div className='grid gap-[16px] grid-cols-12 mt-24'>
            <div className='col-span-6 col-start-4'>
                <div className='text-center'>

                    <img src={Logo} alt="" className='m-auto' />
                    <p className='text-sm my-3'>Bienvenido a Gameif Powered by Loft Media</p>
                    <p className='text-sm text-secundary'> Consulta nuestro aviso de privacidad y contrato de Términos y Condiciones en: https://gameif.media </p>

                </div>
            </div>
        </div>
    )
}


